// Dependencies
import styled from "styled-components";

export const Container = styled.div`
    display: grid;
    margin-block: 1rem;

    @media (min-width: 390px) {
        grid-template-columns: minmax(104px, 32.5%) 60%;
        gap: 1.5rem;
        align-items: center;
    }

    .wrapper-webp-chart-item {
        justify-self: center;

        @media (min-width: 390px) {
            justify-self: start;
        }
    }

    .wrapper-content {
        margin: 1rem 0 0.5rem;

        @media (min-width: 390px) {
            margin: 0 0 0.5rem;
        }
    }
    .wrapper-legends {
        display: grid;

        grid-template-columns: 1fr 1fr;

        @media (min-width: 390px) {
            grid-template-columns: 1fr;
        }

        .webp-chart-legend-item {
            margin-bottom: 0.5rem;
        }

        .webp-chart-legend-item:last-child {
            margin-bottom: 0;
        }
    }
`;
